'use strict';

const googleRecaptcha = require('int_google/googleRecaptcha');

/**
 * Validates email format
 * @param {string} email - Email address to validate
 * @returns {boolean} - Whether email is valid
 */
function isValidEmail(email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
}

/**
 * Validates mobile number format
 * @param {string} mobile - Mobile number to validate
 * @returns {boolean} - Whether mobile number is valid
 */
function isValidMobile(mobile) {
    var mobileRegex = /^[6-9]\d{9}$/;
    return mobileRegex.test(mobile);
}

/**
 * Shows error message for a field
 * @param {jQuery} field - Field to show error for
 * @param {string} message - Error message to display
 */
function showError(field, message) {
    field.addClass('is-invalid');
    // Special handling for mobile field
    if (field.hasClass('contact-us-form-phone')) {
        $('#form-phone-error').removeClass('d-none').text(message);
        field.closest('.input-group').addClass('is-invalid');
    } else {
        field.siblings('.invalid-feedback').removeClass('d-none').text(message);
        if (field.closest('.input-group').length) {
            field.closest('.input-group').addClass('is-invalid');
        }
    }
}

/**
 * Clears error message for a field
 * @param {jQuery} field - Field to clear error for
 */
function clearError(field) {
    field.removeClass('is-invalid');
    // Special handling for mobile field
    if (field.hasClass('contact-us-form-phone')) {
        $('#form-phone-error').addClass('d-none').text('');
        field.closest('.input-group').removeClass('is-invalid');
    } else {
        field.siblings('.invalid-feedback').addClass('d-none').text('');
        if (field.closest('.input-group').length) {
            field.closest('.input-group').removeClass('is-invalid');
        }
    }
}

/**
 * Validates a full name field
 * @param {jQuery} field - The name field to validate
 * @returns {boolean} - Whether the name is valid
 */
function validateFullName(field) {
    var value = field.val().trim();
    if (!/^[a-zA-Z\s]+$/.test(value) || value.length < 3) {
        showError(field, field.attr('data-missing-error'));
        return false;
    }

    clearError(field);
    return true;
}

/**
 * Validates an email field
 * @param {jQuery} field - The email field to validate
 * @returns {boolean} - Whether the email is valid
 */
function validateEmail(field) {
    var value = field.val().trim();
    if (!value || !isValidEmail(value)) {
        showError(field, field.attr('data-pattern-mismatch'));
        return false;
    }

    clearError(field);
    return true;
}

/**
 * Validates a mobile number field
 * @param {jQuery} field - The mobile field to validate
 * @returns {boolean} - Whether the mobile number is valid
 */
function validateMobile(field) {
    var value = field.val().trim();
    var minLength = field.attr('minlength');
    var maxLength = field.attr('maxlength');
    var phoneNolength = value.length;
    var countryCode = $('#contactUsCountryDropdown').val();
    if (!value) {
        showError(field, 'Please enter Mobile Number');
        return false;
    } if ((countryCode === '+91' && !isValidMobile(value)) || phoneNolength < minLength || phoneNolength > maxLength) {
        showError(field, 'Please enter a valid Mobile Number');
        return false;
    }
    clearError(field);
    return true;
}

/**
 * Validates the contact form
 * @param {jQuery} form - Form to validate
 * @returns {boolean} - Whether form is valid
 */
function validateContactForm(form) {
    // Get form fields
    var emailField = form.find('.contact-email-signup');
    var fullNameField = form.find('.contact-fullname');
    var mobileField = form.find('.contact-us-form-phone');

    // Reset all errors
    form.find('.invalid-feedback').addClass('d-none').text('');
    form.find('.is-invalid').removeClass('is-invalid');
    form.find('.input-group').removeClass('is-invalid');

    // Validate all fields and combine results
    var isNameValid = validateFullName(fullNameField);
    var isEmailValid = validateEmail(emailField);
    var isMobileValid = validateMobile(mobileField);

    return isNameValid && isEmailValid && isMobileValid;
}

/**
     * Updates the character count message for a textarea input.
     * Calculates how many characters are remaining and updates the UI.
     */
function updateCharCount() {
    const $textarea = $('.contactus-textarea');
    const maxChars = $textarea.attr('maxlength');
    const $charCount = $('#charCount');

    let currentLength = $textarea.val().length;
    let remaining = maxChars - currentLength;
    $charCount.text(remaining);
}

$('.contactus-textarea').on('input', function () {
    updateCharCount();
});

// Allow only letters and spaces in name input
$('.contact-fullname').on('input', function () {
    $(this).val($(this).val().trimStart().replace(/[^a-zA-Z0-9 ]/g, ''));
    $(this).siblings('.py-cross-right').removeClass('d-none');
    validateFullName($(this));
});

$('.contact-email-signup').on('input', function () {
    $(this).val($(this).val().replace(/[^\w@.\-+]/g, ''));
    $(this).siblings('.py-cross-right').removeClass('d-none');
    validateEmail($(this));
});

$('.contact-us-form-phone').on('input', function () {
    $(this).val($(this).val().replace(/[^0-9]/g, ''));
    $(this).siblings('.py-cross-right').removeClass('d-none');
    if ($(this).val().length === 0) {
        $(this).siblings('.py-cross-right').addClass('d-none');
    }
    validateMobile($(this));
});

/**
 * Handles clearing an input field, hiding the cross icon, and validating the field
 * @param {jQuery} crossIcon - The cross icon element that was clicked
 * @param {string} inputClass - The class of the input field to clear
 * @param {Function} validationFn - The validation function to call
 */
function handleClearInput(crossIcon, inputClass, validationFn) {
    const inputField = crossIcon.siblings(inputClass);
    inputField.val('');
    crossIcon.addClass('d-none');
    validationFn(inputField);
}

// Click handlers for cross icons
$('.contact-fullname').siblings('.py-cross-right').on('click', function () {
    handleClearInput($(this), '.contact-fullname', validateFullName);
});

$('.contact-email-signup').siblings('.py-cross-right').on('click', function () {
    handleClearInput($(this), '.contact-email-signup', validateEmail);
});

$('.contact-us-form-phone').siblings('.py-cross-right').on('click', function () {
    handleClearInput($(this), '.contact-us-form-phone', validateMobile);
});

// Handle form submission
$('.submit-contact-btn').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');

    (googleRecaptcha.getRecaptchaResponse()).then((captchaVerified) => {
        if (captchaVerified) {
            if (validateContactForm($form)) {
                var url = $form.attr('action');
                var formMethod = $form.attr('method');

                var serializedData = $form.serialize();
                $.ajax({
                    url: url,
                    type: formMethod,
                    data: serializedData,
                    timeout: 20000
                });
                $('body').trigger('successToast', 'Your message has been sent successfully.');

                $form[0].reset();
                $form.find('input').removeClass('has-value');
                $form.find('.py-cross-right').removeClass('show').addClass('d-none');
                var defaultFlagSrc = $('#hiddenFlag').val();
                $('.country-flag-img-contact-us img').attr('src', defaultFlagSrc);
                updateCharCount();
            }
        }
    });
});

$(document).ready(function () {
    updateCharCount();
});
